import { render, staticRenderFns } from "./aed-icon.vue?vue&type=template&id=49766482&scoped=true&"
import script from "./aed-icon.vue?vue&type=script&lang=js&"
export * from "./aed-icon.vue?vue&type=script&lang=js&"
import style0 from "./aed-icon.vue?vue&type=style&index=0&id=49766482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49766482",
  null
  
)

export default component.exports